export default __webpack_public_path__ + "static/media/onsport_preview.f1782ef7.png";